import { capitalize, each, keyBy, filter } from 'lodash'
import { INIT_CURRENT_RUBRIC, SET_CURRENT_FORMAT } from '../types/rubric'
import { TYPE_REPORT } from '../../lib/constants'

const state = {
  currentRubric: null,
  currentFormat: {},
  currentMetrics: {}
}

const getters = {
  currentRubric: state => state.currentRubric,
  currentFormat: state => state.currentFormat,
  currentMetrics: state => state.currentMetrics
}

function handleMetricOptions(metric) {
  each(metric.options, function(option) {
    let { minValue, midValue, maxValue, description } = option
    option.description = `${description} (${minValue}-${maxValue}%)`
    option.midValue = parseFloat(midValue)
    option.minValue = parseFloat(minValue)
    option.maxValue = parseFloat(maxValue)
  })
}

function handleFormat(sourceFormat) {
  let format = keyBy(sourceFormat, 'chunkType')
  let reportFormat = format[TYPE_REPORT]
  if (reportFormat) {
    let metrics = []
    each(reportFormat.views, function(view) {
      if (view.metric) {
        metrics.push(view.metric)
      } else if (view.groups) {
        each(view.groups, function(group) {
          group.code = group.title.toLocaleLowerCase()
          if (group.metrics) {
            each(group.metrics, metric => {
              metrics.push(metric)
            })
          }
        })
      }
    })
    each(metrics, metric => {
      state.currentMetrics[metric.code] = metric
      handleMetricOptions(metric)
      state.currentRubric.metrics[metric.code].metricBands = metric.options
    })
  }
  return format
}

const actions = {
  /**
   * Pull current rubric from API
   *
   * @param ctx
   */
  [INIT_CURRENT_RUBRIC](ctx) {
    let rootGetters = ctx.rootGetters

    return ctx.rootState.api
      .getCurrentRubric({
        options: rootGetters.authOptions
      })
      .then(function(rubric) {
        ctx.commit(INIT_CURRENT_RUBRIC, {
          rubric
        })
        rubric.metrics = keyBy(rubric.metrics, 'code')

        let format = rubric.format
        if (format) {
          format = handleFormat(format)
          ctx.commit(SET_CURRENT_FORMAT, {
            format
          })
        }
        let dependencies = {}
        each(rubric.metrics, function(metric, key) {
          metric.key = key
          if (!metric.title) {
            metric.title = metric.name || capitalize(key)
          }
          if (metric.function) {
            metric.fn = metric.function
            // dependencies is already defined in src/api/rubric/current.json.
            try {
              metric.dependencies = filter(
                metric.fn.split(/avg\(|min\(|weighted\(|[\d+\W+\-,]+/g),
                o => o.length
              )
            } catch (e) {
              // pass
            }
          }
          if (metric.dependencies) {
            each(metric.dependencies, function(dep) {
              if (dep in dependencies) {
                dependencies[dep].push(key)
              } else {
                dependencies[dep] = [key]
              }
            })
          }
        })
        rubric.dependencies = dependencies
        return rubric
      })
  }
}

const mutations = {
  [INIT_CURRENT_RUBRIC](state, change) {
    state.currentRubric = change.rubric
  },
  [SET_CURRENT_FORMAT](state, change) {
    state.currentFormat = change.format
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
